import React from 'react';
import { Card, Container, Row, Col } from 'react-bootstrap';

const owner = {
  name: 'Jerry Browning',
  email: 'Dave@Northstar-Distributors.com',
  phone: '(951) 285-8867'
};

const General = {
  name: 'Customer Service',
  email: 'Info@Northstar-Distributors.com',
  phone: '(951) 285-8867'
};

const cardStyle = {
  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.6)',
  paddingBottom: '1px',
  marginBottom: '20px',
};

const OwnerInfoCard = () => {
  return (
    <Container className="mt-5 owner-card-container">
      <Card style={cardStyle}>
        <Card.Body >
          <Card.Title>Owner</Card.Title>
          <Row>
            <Col md={6}>
              <Card.Text><strong>Name:</strong> {owner.name}</Card.Text>
              <Card.Text><strong></strong> {}</Card.Text>
            </Col>
            <Col md={6}>
              <Card.Text><strong>Phone Number:</strong> {owner.phone}</Card.Text>
            </Col>
          </Row>
        </Card.Body>
      </Card >
      <Card  style={cardStyle} className='mb-5'>
        <Card.Body >
          <Card.Title>General Information</Card.Title>
          <Row>
            <Col md={6}>
              <Card.Text><strong>Department:</strong> {General.name}</Card.Text>
              <Card.Text><strong>Email:</strong> {General.email}</Card.Text>
            </Col>
            <Col md={6}>
              <Card.Text><strong>Phone Number:</strong> {General.phone}</Card.Text>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default OwnerInfoCard;
